import { project } from "../../system/types/project/project";

export enum PROJECT_ACTIONS {
    setProjectId = 'SET_PROJECT_ID',
    setProjectData = 'SET_PROJECT_DATA',
    setPageCommand = 'SET_PROJECT_PAGET_COMMAND',
    setPageCommandID = 'SET_PROJECT_PAGET_COMMAND_ID',
    setPageCommandSubSelect = 'SET_PROJECT_PAGET_COMMAND_SUBSELECT',
    clearProjectData = 'CLEAR_PROJECT_DATA'
};

export type ProjectState = {
    projectId: string;
    projectData: project;
    pageCommand: string;
    pageCommandId: string;
    pageCommandSubSelect: string;
};
